$(document).ready(function() {
  $(".click-analytics").on('click', (e) => {
    const button = $(e.target)
    const event = button.data("event")
    const type = button.data("analyticstype")
    const btnType = event === 'form' ? 'formtype' : 'btntype'
    const analytic = {
      event,
      [btnType]: type,
    }
    dataLayer.push(analytic)
  });
})



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/click-analytics.js